import { useEffect } from 'react';
import { useAuthStore } from '../../auth/state/authStore';

function normalizeReferralCode(raw: string | null): string | null {
  if (!raw) {
    return null;
  }
  const trimmed = raw.trim().toUpperCase();
  return trimmed.length ? trimmed : null;
}

export function useReferralAttribution() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const referralCode = normalizeReferralCode(params.get('ref'));
    if (!referralCode) {
      return;
    }
    const store = useAuthStore.getState();
    if (normalizeReferralCode(store.draft.referralCode) === referralCode) {
      return;
    }
    store.updateDraft({ referralCode });
  }, []);
}
